import { $color_grey_8 } from '../pebbleGlobalToken/color.js';

/**
 * 气泡卡片-控制内容文字颜色
 * @description enDesc: -
 * @description type: Shadow
 * @description value: $color_grey_8
 */
var $popover_color_text = $color_grey_8;

/**
 * 气泡卡片-popver padding间距
 * @description enDesc: -
 * @description type: Space
 * @description value: 16
 */
var $popover_popover_padding = 20;

export { $popover_color_text, $popover_popover_padding };
